import React, { useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useStateContext } from "../contexts/ContextProvider";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import {
  apiAchCheckout,
  apiCardCheckout,
  apiCreateSubscription,
} from "../services/apiService";
import { useParams } from "react-router-dom";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const CheckoutSubscription = () => {
  const { setNavigateToDashboard } = useStateContext();
  const { subscriptionType } = useParams();

  console.log(subscriptionType);

  const fetchClientSecret = useCallback(async () => {
    let response;
    setNavigateToDashboard(false);

    response = await apiCreateSubscription(subscriptionType);
    return response.data.clientSecret;
  }, []);

  const options = { fetchClientSecret };

  return (
    <div id="checkout" className="mt-32">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default CheckoutSubscription;
